<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Campos de Catálogo
      </h1>
      <p class="text-gray-600 dark:text-gray-400">
        Definición de campos dinámicos para cada catálogo
      </p>
    </div>

    <!-- Selector de Catálogo -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 mb-6">
      <div class="p-6">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Seleccionar Catálogo
        </label>
        <select
          v-model="catalogoSeleccionado"
          @change="onCatalogoChange"
          class="w-full px-3 py-2 rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200"
        >
          <option :value="null">Seleccione un catálogo...</option>
          <option v-for="catalogo in catalogos" :key="catalogo.catalogoId" :value="catalogo">
            {{ catalogo.nombreCatalogo }}
          </option>
        </select>
      </div>
    </div>

    <!-- Tabla de Campos -->
    <div v-if="catalogoSeleccionado" class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <div class="flex justify-between items-center">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
            Campos de: {{ catalogoSeleccionado.nombreCatalogo }}
          </h2>
          <button
            @click="openModal()"
            class="bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            Nuevo Campo
          </button>
        </div>
      </div>

      <div class="p-6">
        <div v-if="loading" class="text-center py-8">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-violet-600 mx-auto"></div>
        </div>

        <div v-else class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs uppercase bg-gray-100 dark:bg-gray-800 dark:text-gray-300 border-b-2 border-gray-200 dark:border-gray-700">
              <tr>
                <th class="px-4 py-2 font-bold">Orden</th>
                <th class="px-4 py-2 font-bold">Nombre Campo</th>
                <th class="px-4 py-2 font-bold">Suma al Costo</th>
                <th class="px-4 py-2 font-bold">Multiplicar Por</th>
                <th class="px-4 py-2 font-bold">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="campo in campos"
                :key="campo.campoId"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 even:bg-gray-50 dark:even:bg-gray-700"
              >
                <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">
                  {{ campo.orden }}
                </td>
                <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">
                  {{ campo.nombreCampo }}
                </td>
                <td class="px-4 py-2">
                  <span v-if="campo.esMonto" class="text-green-600 dark:text-green-400">✓</span>
                  <span v-else class="text-gray-400">-</span>
                </td>
                <td class="px-4 py-2">
                  <span v-if="campo.esMonto && campo.tipoCalculo" class="text-xs px-2 py-1 rounded"
                    :class="{
                      'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200': campo.tipoCalculo === 'area_papel',
                      'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200': campo.tipoCalculo === 'area_corrugado',
                      'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-200': campo.tipoCalculo === 'excedente_costo_papel',
                      'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200': campo.tipoCalculo === 'valor_directo'
                    }">
                    {{ campo.tipoCalculo === 'area_papel' ? 'Área Papel' : campo.tipoCalculo === 'area_corrugado' ? 'Área Corrugado' : campo.tipoCalculo === 'excedente_costo_papel' ? 'Excedente' : 'Nada' }}
                  </span>
                  <span v-else class="text-gray-400">-</span>
                </td>
                <td class="px-4 py-2">
                  <div class="flex gap-2">
                    <button @click="openModal(campo)" class="text-blue-600 hover:text-blue-800">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                    </button>
                    <button @click="eliminar(campo)" class="text-red-600 hover:text-red-800">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="campos.length === 0">
                <td colspan="5" class="px-4 py-8 text-center text-gray-500 dark:text-gray-400">
                  No hay campos definidos para este catálogo
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div class="p-6 border-b border-gray-200 dark:border-gray-700">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            {{ editando ? 'Editar Campo' : 'Nuevo Campo' }}
          </h3>
        </div>

        <div class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Nombre del Campo *
            </label>
            <input
              v-model="formData.nombreCampo"
              type="text"
              class="w-full px-3 py-2 rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200"
              placeholder="Ej: COSTO"
            />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Orden
            </label>
            <input
              v-model.number="formData.orden"
              type="number"
              class="w-full px-3 py-2 rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200"
            />
          </div>

          <div class="space-y-3">
            <label class="flex items-center">
              <input
                v-model="formData.esMonto"
                type="checkbox"
                class="w-4 h-4 text-violet-600 bg-gray-100 border-gray-300 rounded focus:ring-violet-500"
              />
              <span class="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">Sumar al costo del prototipo</span>
            </label>

            <div v-if="formData.esMonto">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Multiplicar por:
              </label>
              <select
                v-model="formData.tipoCalculo"
                @change="formData.esCalculado = formData.tipoCalculo !== 'valor_directo'"
                class="w-full px-3 py-2 rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200"
              >
                <option value="valor_directo">Nada (usar valor directo)</option>
                <option value="area_papel">Área Papel (m²)</option>
                <option value="area_corrugado">Área Corrugado (m²)</option>
                <option value="excedente_costo_papel">Excedente (Valor × Área Papel × Otro Campo)</option>
              </select>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Al crear registros del catálogo, se ingresará un valor base. En el prototipo, ese valor se multiplicará según la opción seleccionada.
              </p>
              <p class="text-xs text-blue-600 dark:text-blue-400 mt-1 font-medium">
                💡 Ejemplo: Valor base $100 × Área papel 2m² = $200 en el prototipo
              </p>
            </div>

            <!-- Selector de campo de referencia para excedente_costo_papel -->
            <div v-if="formData.esMonto && formData.tipoCalculo === 'excedente_costo_papel'">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Campo a multiplicar (Ajuste) *
              </label>
              <select
                v-model="formData.campoReferenciaId"
                class="w-full px-3 py-2 rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200"
              >
                <option :value="null">Seleccione el campo...</option>
                <option v-for="campo in campos.filter(c => c.esMonto && c.campoId !== editando?.campoId)" :key="campo.campoId" :value="campo.campoId">
                  {{ campo.nombreCampo }}
                </option>
              </select>
              <p class="text-xs text-orange-600 dark:text-orange-400 mt-1 font-medium">
                📊 La fórmula será: Valor × Área Papel × [Campo Seleccionado]
              </p>
            </div>
          </div>

          <div v-if="formData.esMonto && formData.tipoCalculo !== 'valor_directo'" class="space-y-4">

            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Fórmula de Cálculo (opcional)
              </label>
              <textarea
                v-model="formData.formulaCalculo"
                rows="3"
                class="w-full px-3 py-2 rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-violet-200"
                placeholder="Fórmula personalizada (opcional)"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-2">
          <button
            @click="closeModal"
            class="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
          >
            Cancelar
          </button>
          <button
            @click="guardar"
            :disabled="loading"
            class="px-4 py-2 bg-violet-600 hover:bg-violet-700 text-white rounded-lg transition disabled:opacity-50"
          >
            {{ loading ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useCatalogosNew } from '../../composables/useCatalogosNew'

const {
  loading,
  catalogos,
  campos,
  fetchCatalogos,
  fetchCamposByCatalogo,
  createCampo,
  updateCampo,
  deleteCampo
} = useCatalogosNew()

const catalogoSeleccionado = ref(null)
const showModal = ref(false)
const editando = ref(null)
const formData = ref({
  nombreCampo: '',
  esMonto: false,
  esCalculado: false,
  tipoCalculo: 'valor_directo',
  formulaCalculo: '',
  campoReferenciaId: null,
  orden: 0
})

onMounted(async () => {
  await fetchCatalogos()
})

const onCatalogoChange = async () => {
  if (catalogoSeleccionado.value) {
    await fetchCamposByCatalogo(catalogoSeleccionado.value.catalogoId)
  }
}

const openModal = (campo = null) => {
  if (campo) {
    editando.value = campo
    formData.value = {
      nombreCampo: campo.nombreCampo,
      esMonto: campo.esMonto,
      esCalculado: campo.esCalculado,
      tipoCalculo: campo.tipoCalculo || 'valor_directo',
      formulaCalculo: campo.formulaCalculo || '',
      orden: campo.orden
    }
  } else {
    editando.value = null
    formData.value = {
      nombreCampo: '',
      esMonto: false,
      esCalculado: false,
      tipoCalculo: 'valor_directo',
      formulaCalculo: '',
      orden: (campos.value.length + 1)
    }
  }
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
  editando.value = null
}

const guardar = async () => {
  try {
    const data = {
      ...formData.value,
      catalogoId: catalogoSeleccionado.value.catalogoId
    }

    if (editando.value) {
      await updateCampo(editando.value.campoId, data)
    } else {
      await createCampo(data)
    }
    closeModal()
    await fetchCamposByCatalogo(catalogoSeleccionado.value.catalogoId)
  } catch (error) {
    console.error('Error al guardar:', error)
  }
}

const eliminar = async (campo) => {
  if (confirm(`¿Está seguro de eliminar el campo "${campo.nombreCampo}"?`)) {
    try {
      await deleteCampo(campo.campoId, catalogoSeleccionado.value.catalogoId)
    } catch (error) {
      console.error('Error al eliminar:', error)
    }
  }
}
</script>
